import Metadata from './metadata';

export default function (country, metadata) {
	metadata = new Metadata(metadata);

	if (!metadata.hasCountry(country)) {
		throw new Error('Unknown country: ' + country);
	}

	return metadata.country(country).countryCallingCode();
}
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountryCallingCode.js
// module id = 158
// module chunks = 0